import React from 'react';
import { LayoutDashboard, Package, FileText, Users, Factory, File, FlaskConical, FileStack, ShieldCheck, IceCream } from 'lucide-react';
export function Sidebar() {
  return <aside className="w-60 bg-white border-r border-gray-200 h-screen fixed top-0 left-0 overflow-y-auto" data-id="element-39">
      {/* Logo */}
      <div className="p-6 border-b border-gray-200" data-id="element-40">
        <div className="flex items-center space-x-3" data-id="element-41">
          <div className="w-6 h-6 bg-purple-600 rounded flex items-center justify-center" data-id="element-42">
            <IceCream className="w-4 h-4 text-white" data-id="element-43" />
          </div>
          <div className="flex flex-col" data-id="element-44">
            <span className="text-purple-600 font-medium text-sm" data-id="element-45">Scoop</span>
            <span className="text-gray-500 text-xs" data-id="element-46">Scoop</span>
          </div>
        </div>
      </div>
      {/* Navigation */}
      <div className="py-4" data-id="element-47">
        {/* System Section */}
        <div className="px-4 mb-2" data-id="element-48">
          <h3 className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-49">
            System
          </h3>
        </div>
        <ul className="space-y-1 px-2" data-id="element-50">
          <li data-id="element-51">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-52">
              <ShieldCheck className="w-5 h-5" data-id="element-53" />
              <span className="text-sm" data-id="element-54">Super Admin</span>
            </a>
          </li>
        </ul>
        {/* Platform Section */}
        <div className="px-4 mt-6 mb-2" data-id="element-55">
          <h3 className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-56">
            Platform
          </h3>
        </div>
        <ul className="space-y-1 px-2" data-id="element-57">
          <li data-id="element-58">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md bg-purple-100 text-purple-700" data-id="element-59">
              <LayoutDashboard className="w-5 h-5" data-id="element-60" />
              <span className="text-sm" data-id="element-61">Dashboard</span>
            </a>
          </li>
          <li data-id="element-62">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-63">
              <Package className="w-5 h-5" data-id="element-64" />
              <span className="text-sm" data-id="element-65">Products</span>
            </a>
          </li>
          <li data-id="element-66">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-67">
              <FileText className="w-5 h-5" data-id="element-68" />
              <span className="text-sm" data-id="element-69">Claims</span>
            </a>
          </li>
          <li data-id="element-70">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-71">
              <Users className="w-5 h-5" data-id="element-72" />
              <span className="text-sm" data-id="element-73">Suppliers</span>
            </a>
          </li>
          <li data-id="element-74">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-75">
              <Factory className="w-5 h-5" data-id="element-76" />
              <span className="text-sm" data-id="element-77">Manufacturers</span>
            </a>
          </li>
          <li data-id="element-78">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-79">
              <File className="w-5 h-5" data-id="element-80" />
              <span className="text-sm" data-id="element-81">Documents</span>
            </a>
          </li>
        </ul>
        {/* Projects Section */}
        <div className="px-4 mt-6 mb-2" data-id="element-82">
          <h3 className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-83">
            Projects
          </h3>
        </div>
        <ul className="space-y-1 px-2" data-id="element-84">
          <li data-id="element-85">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-86">
              <FlaskConical className="w-5 h-5" data-id="element-87" />
              <span className="text-sm" data-id="element-88">Research</span>
            </a>
          </li>
          <li data-id="element-89">
            <a href="#" className="flex items-center space-x-3 px-3 py-2 rounded-md text-gray-700 hover:bg-purple-50 hover:text-purple-700" data-id="element-90">
              <FileStack className="w-5 h-5" data-id="element-91" />
              <span className="text-sm" data-id="element-92">Papers</span>
            </a>
          </li>
        </ul>
      </div>
    </aside>;
}